import MenuItem from '@mui/material/MenuItem'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import Icon from '@mui/material/Icon'
import Divider from '@mui/material/Divider'
import { useTranslation } from 'react-i18next'

import { FilterItem } from 'types/FilterBuilder'
import variables from 'assets/styles/scss/shared/_variables.module.scss'

type MenuProps = {
  item: FilterItem
  index: number
  isDisabled: boolean | undefined
  handleMenuClick: (item: any) => void
}

export const getMenuItem = (props: MenuProps) => {
  const { item, isDisabled, handleMenuClick, index } = props
  const { t } = useTranslation()
  const icon = item.icon

  const iconStyle = item.iconStyle ? `material-icons-${item.iconStyle}` : ''
  return (
    <Box key={index}>
      <MenuItem
        disabled={isDisabled}
        onClick={() => handleMenuClick(item)}
        data-testid={item.name}
      >
        <Stack direction="row" spacing={2}>
          {/**
           * Make sure that you add icons in snake case,
           * since some of the camelCase icons are not supprted
           */}
          {icon && (
            <Icon
              className={iconStyle}
              sx={{ color: variables['icon-active'] }}
            >
              {icon}
            </Icon>
          )}
          <Typography variant="body1">
            {t(`filters.${item.name}.label`)}
          </Typography>
        </Stack>
      </MenuItem>
      {item?.divider && <Divider />}
    </Box>
  )
}
